const GA_MEASUREMENT_ID = (process.env.REACT_APP_GA_MEASUREMENT_ID || "").trim();
let analyticsLoaded = false;

export function shouldTrackPath(pathname) {
  return !(
    pathname === "/admin" ||
    pathname.startsWith("/admin/") ||
    pathname === "/preview" ||
    pathname.startsWith("/preview/")
  );
}

function normalizedPath(pathname) {
  // Avoid sending condition-specific paths to Analytics.
  return pathname.startsWith("/care/") ? "/care" : pathname;
}

export function loadAnalytics() {
  if (!GA_MEASUREMENT_ID || analyticsLoaded) return;
  const initialPath = normalizedPath(window.location.pathname);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
    allow_google_signals: false,
    anonymize_ip: true,
    page_path: initialPath,
    page_location: `${window.location.origin}${initialPath}`,
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
  script.dataset.ga4 = GA_MEASUREMENT_ID;
  document.head.appendChild(script);
  analyticsLoaded = true;
}

export function trackPageView(pathname) {
  if (!GA_MEASUREMENT_ID || !window.gtag || !shouldTrackPath(pathname)) return;
  const path = normalizedPath(pathname);
  const location = `${window.location.origin}${path}`;
  window.gtag("set", {
    page_path: path,
    page_location: location,
  });
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: location,
  });
}

export function trackLeadSubmission() {
  if (!GA_MEASUREMENT_ID || !window.gtag || !shouldTrackPath(window.location.pathname)) return;
  window.gtag("event", "generate_lead");
}
